import { useUsecaseUser as useUsecaseUserCore } from '@cpsy-rmap-project/web-core/usecases'
import { useAuth } from 'reactfire'

export const useUsecaseUser = () => useUsecaseUserCore({ auth: useAuth() })
